import React from "react";
import { IContactDistanceData } from "../../exports/interfaces";

const LocationTime = (props: { contactDistance: IContactDistanceData[] }) => {
  return (
    <>
      <section
        className="elementor-section elementor-top-section elementor-element elementor-element-792a63f elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="792a63f"
        data-element_type="section"
        data-settings='{"hoteller_ext_is_background_parallax":"false","hoteller_ext_is_background_on_scroll":"false"}'
      >
        <div className="elementor-container elementor-column-gap-wide">
          <div
            className="elementor-row custom-row-element custom-layout_tg_three_cols"
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "16px",
              padding: "0% 10%",
            }}
          >
            {props?.contactDistance?.map((distance) => (
              <div
                className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-f75bb7e custom-contact-elementor-widget-wrap"
                data-id="f75bb7e"
                data-element_type="column"
                data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                // style={{ width: "25%" }}
              >
                <div className="elementor-column-wrap elementor-element-populated">
                  <div className="elementor-widget-wrap">
                    <div
                      className="elementor-element elementor-element-b52be93 elementor-widget elementor-widget-text-editor"
                      data-id="b52be93"
                      data-element_type="widget"
                      data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                      data-widget_type="text-editor.default"
                    >
                      <div className="elementor-widget-container">
                        <div className="elementor-text-editor elementor-clearfix">
                          <p>
                            <strong>{distance?.title}</strong>
                            <br />
                            <span
                              dangerouslySetInnerHTML={{
                                __html: distance?.description,
                              }}
                            />
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default LocationTime;
